import { useState } from "react";
import ForgotPasswordEmail from "../components/ForgotPasswordEmail";
import ResetPassword from "../components/ResetPassword";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Helmet } from 'react-helmet';
import Footer from "../components/Footer";

const ForgotPasswordPage = () => {
    const { t, i18n } = useTranslation();
    const [emailSubmitted, setEmailSubmitted] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const handleEmailSubmit = () => {
        setEmailSubmitted(true);
    };

    return (
        <>
            <Helmet>
                <title>{t('meta.forgotPassword.title')}</title>
                <meta name="description" content={t('meta.forgotPassword.description')} />
            </Helmet>
            <div className='min-h-screen bg-gradient-to-br from-cyan-200 via-white to-pink-300 flex flex-col'>
                <main className="flex-1">
                    <div className='flex justify-between items-center px-4 py-4 lg:px-10 relative'>
                        <Link to="/" className="flex items-center gap-2 shrink-0 no-underline">
                            <img src="/logo2.png" className="w-8 h-8 md:w-9 md:h-9" alt="Weddinfy" />
                            <span className="font-display text-xl md:text-[22px] font-semibold text-stone-900">Weddinfy</span>
                        </Link>
                        <div className="flex items-center space-x-4">
                            {/* Language Dropdown */}
                            {/* <div className="relative" tabIndex={0} onBlur={() => setOpenDropdown(null)}>
                                <div className="bg-white border border-gray-500 rounded-xl px-2 cursor-pointer flex items-center" onClick={() => setOpenDropdown(prev => prev === "language" ? null : "language")} >
                                    <span className="text-gray-800 uppercase">
                                        {i18n.language === 'hr' && '🌐'}
                                        {i18n.language === 'en' && '🇬🇧'}
                                        {i18n.language === 'de' && '🇩🇪'}
                                    </span>
                                    {openDropdown === "language" ? (
                                        <FaChevronUp className="ml-2 text-gray-600" />
                                    ) : (
                                        <FaChevronDown className="ml-2 text-gray-600" />
                                    )}
                                </div>

                                {openDropdown === "language" && (
                                    <div className="absolute right-0 mt-1 z-50 w-full min-w-[130px] bg-white border border-gray-500 rounded-xl shadow-lg">
                                        {[
                                            { code: 'hr', label: 'Jezik', flag: '🌐' },
                                            { code: 'en', label: 'English', flag: '🇬🇧' },
                                            { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
                                        ].map((lang) => (
                                            <button key={lang.code} type="button"
                                                onMouseDown={() => {
                                                    i18n.changeLanguage(lang.code);
                                                    setOpenDropdown(null);
                                                }}
                                                className="w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 rounded-xl flex items-center gap-2">
                                                <span className="text-xl">{lang.flag}</span>
                                                <span>{lang.label}</span>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                        </div>
                    </div>
                    {!emailSubmitted ? (
                        <ForgotPasswordEmail onEmailSubmit={handleEmailSubmit} />
                    ) : (
                        <ResetPassword />
                    )}
                </main>
                <footer>
                    <Footer />
                </footer>
            </div>
        </>
    );
};

export default ForgotPasswordPage;
